import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'styles/jss/original/components/menus/detailStep';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
};

const DetailStep: React.FC<ComponentProps> = ({ menu }) => {
  const classes = useStyles();
  const { step } = menu.fields;

  if (step.length === 0) return null;
  return (
    <div className={classes.section}>
      <h4 className={classes.title}>作り方</h4>
      {step.map((item, index) => {
        return (
          <div key={item}>
            <h5 className={classes.step}>{index + 1}</h5>
            <p>{item}</p>
          </div>
        );
      })}
    </div>
  );
};

export default DetailStep;
